import { render, staticRenderFns } from "./TranslationPromptField.vue?vue&type=template&id=64c865e2&"
import script from "./TranslationPromptField.vue?vue&type=script&lang=js&"
export * from "./TranslationPromptField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports